import { call, put, select } from 'redux-saga/effects';
import Swal from 'sweetalert2';
import api from '../../../service/api';
import { SKW_AUTH, SKW_PREFIX } from '../../../utils/constants';

import { loadSuccess, loadFailure, loadRequest } from './actions';

export function* loadHorariosDisponiveis({ payload }: ReturnType<typeof loadRequest>): any {
  try {
    const state = yield select();
    const response = yield call(
      api.post,
      `call?serviceName=${SKW_PREFIX}getHorariosDisponiveis&accessKey=${SKW_AUTH}&token=${state.auth.token}`,
      {
        dia: payload.dia,
        codTipoCarroceria: payload.codTipoCarroceria,
        codCdd: payload.codCdd,
        codEmp: payload.codEmp,
        ordemCarga: payload.ordemCarga,
      }
    );
    yield put(loadSuccess(response.data?.agendamentosVagos));
  } catch (error: any) {
    yield put(loadFailure());
    if (error.response.data.Erro) {
      Swal.fire({
        title: 'Opss...',
        html: `${error.response?.data?.Erro}`,
        icon: 'warning',
      });
    } else {
      Swal.fire({
        title: 'Opss...',
        html:
          'Ocorreu um erro ao buscar os horários disponíveiss, por favor atualize a página, se persistir contate o suporte técnico!.',
        icon: 'warning',
      });
    }
  }
}
